<template>
	<section class="view-ui-icon-home">
		<svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M24 7.62905V20.4287C23.9993 21.1105 23.7181 21.7641 23.2182 22.2461C22.7182 22.7282 22.0404 22.9993 21.3333 23H16.8889C16.4174 23 15.9652 22.8194 15.6318 22.4979C15.2984 22.1765 15.1111 21.7405 15.1111 21.2858V16.5719C15.1111 16.3446 15.0175 16.1266 14.8508 15.9658C14.6841 15.8051 14.458 15.7148 14.2222 15.7148H9.77778C9.54203 15.7148 9.31594 15.8051 9.14924 15.9658C8.98254 16.1266 8.88889 16.3446 8.88889 16.5719V21.2858C8.88889 21.7405 8.70159 22.1765 8.36819 22.4979C8.03479 22.8194 7.58261 23 7.11111 23H2.66667C1.95964 22.9993 1.28177 22.7282 0.781828 22.2461C0.281884 21.7641 0.000705969 21.1105 0 20.4287V7.62905C0.000665148 7.33305 0.0804379 7.04221 0.231621 6.78459C0.382805 6.52697 0.600296 6.31127 0.863111 6.1583L11.0853 0.244414C11.3617 0.084484 11.6779 0 12.0002 0C12.3225 0 12.6388 0.084484 12.9151 0.244414L23.1373 6.1583C23.4001 6.31132 23.6175 6.52704 23.7686 6.78466C23.9197 7.04228 23.9994 7.33309 24 7.62905Z"
				fill="currentColor"
			/>
		</svg>
	</section>
</template>

<script lang="ts">
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Ui/Icon
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewUiIconHome extends ViewBase {
		// Not implemented
	}
</script>
